/**
 * Maps route pathnames to their default workflow phase.
 * Used when there is no explicit ?phase=N in the URL.
 * Returns null for routes that should NOT show the stepper (Dashboard, profile, settings, etc.).
 */

interface RoutePhaseEntry {
  pattern: RegExp
  phase: number
}

const ROUTE_PHASE_MAP: RoutePhaseEntry[] = [
  // Phase 1 - Planejamento
  { pattern: /^\/projects\/?$/, phase: 1 },
  { pattern: /^\/projects\/[^/]+\/?$/, phase: 1 },
  { pattern: /^\/projects\/[^/]+\/activities\/?$/, phase: 1 },
  { pattern: /^\/units\/?$/, phase: 1 },
  { pattern: /^\/settings\/planejamentos\/?$/, phase: 1 },
  { pattern: /^\/settings\/planejamentos\/[^/]+\/?$/, phase: 1 },

  // Phase 2 - Levantamento
  { pattern: /^\/levantamento\/?$/, phase: 2 },
  { pattern: /^\/projects\/[^/]+\/levantamento\/?$/, phase: 2 },
  { pattern: /^\/projects\/[^/]+\/review-activities\/?$/, phase: 2 },
  { pattern: /^\/projects\/[^/]+\/levantamento-report\/?$/, phase: 2 },

  // Phase 3 - Contratacao
  { pattern: /^\/suppliers\/?$/, phase: 3 },
  { pattern: /^\/suppliers\/[^/]+\/?$/, phase: 3 },
  { pattern: /^\/purchases\/?$/, phase: 3 },

  // Phase 4 - Mobilizacao
  { pattern: /^\/contractors\/?$/, phase: 4 },
  { pattern: /^\/contractors\/[^/]+\/?$/, phase: 4 },

  // Phase 7 - Medicao
  { pattern: /^\/financial\/?$/, phase: 7 },

  // Phase 8 - Encerramento
  { pattern: /^\/projects\/[^/]+\/close\/?$/, phase: 8 },
]

export function getDefaultPhaseForRoute(pathname: string): number | null {
  for (const entry of ROUTE_PHASE_MAP) {
    if (entry.pattern.test(pathname)) {
      return entry.phase
    }
  }
  return null
}
